export class LocationGeusDataItem {
    public locationNumber: string | null;
    public dataQuality: string | null;
    public coverThickness: number;
    public aquiferDepth: number;
    public groundWater: number;
    public elevation: number;
    public flowdir: number;
    public headGradient: number;
    public infiltration: number;
    public lithoName: string | null;
    public redox: number;
    public complexGeology: string | null;
    public distNoClay: number;
    public distNearestWaterWell: number;
    public pollutionStatus: string | null;
    public updateDate: Date | null;
    public polygonArea: string | null;
    public HasBoringWithoutClay: boolean | undefined;
    public area: number | null | undefined;

    public constructor(init: Partial<LocationGeusDataItem>) {
        Object.assign(this, init);
    }
}
